import { render, staticRenderFns } from "./chat-message-check.vue?vue&type=template&id=41e59e50&scoped=true"
import script from "./chat-message-check.vue?vue&type=script&lang=js"
export * from "./chat-message-check.vue?vue&type=script&lang=js"
import style0 from "./chat-message-check.vue?vue&type=style&index=0&id=41e59e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e59e50",
  null
  
)

export default component.exports